export default __webpack_public_path__ + "static/media/metalwall2.afad0341.png";